import { SalesActionsType } from 'api-hooks/general/model';
import { SaleModel } from 'api-hooks/sale/common';
import { EditSVG } from 'common/assets';
import { AuthorizationRules } from 'common/constants';
import { SaleStatusEnum } from 'common/constants/enum';
import { Button } from 'components/elements';
import { useFormState } from 'components/elements/form';
import { PopoverMenuType } from 'components/popover';
import { useAuthorization } from 'hooks/use-authorization';
import { ActionContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

export default function useSalesEditAction(
  data: SaleModel,
  type: SalesActionsType,
) {
  const { t } = useTranslation();

  const { can } = useAuthorization();
  const authorizationRule = React.useMemo(() => {
    switch (type) {
      case 'flight-sales':
        return AuthorizationRules.FlightSalesCreate;
      case 'hotel-sales':
        return AuthorizationRules.HotelSalesCreate;
      case 'cruise-sales':
        return AuthorizationRules.CruiseSalesCreate;
      case 'document-sales':
        return AuthorizationRules.DocumentSalesCreate;
      case 'activity-sales':
        return AuthorizationRules.ActivitySalesCreate;
      case 'product-sales':
        return AuthorizationRules.ProductSalesCreate;
      case 'tour-sales':
        return AuthorizationRules.TourSalesCreate;
    }
  }, [type]);

  const isCompleted = data.isCompleted;
  const status = data.status;

  const isAllowed = React.useMemo(() => {
    switch (status) {
      case SaleStatusEnum.Active:
      case SaleStatusEnum.OpenTicket:
        return !isCompleted;
      default:
        return false;
    }
  }, [isCompleted, status]);

  const editPermissions = isAllowed && can(authorizationRule);
  const { setIsEditable } = useFormState();

  const editAction: PopoverMenuType = {
    key: `edit-${data.id}`,
    onClick() {
      setIsEditable(true);
    },
    isAllowed: editPermissions,
    label: t('common:edit_invoice'),
  };

  const editComponent = editPermissions && (
    <Button
      onClick={() => setIsEditable(true)}
      startEnhancer={(color, size) => (
        <ActionContainer $style={{ marginRight: '8px' }}>
          <EditSVG size={size} color={color} />
        </ActionContainer>
      )}
    >
      {t('common:edit')}
    </Button>
  );

  return {
    editAction,
    editPermissions,
    editComponent,
  };
}
